import { createContext } from 'react';

import { DEFAULT_TOOLSET, Toolset } from '../plugins/ToolbarPlugin';

export interface BubbleConfig {
  id: string;
  height: number;
  editable: boolean;
  fitToContent: boolean;
  toolset: Toolset;
  placeholderText?: string;
  characterLimit?: number;
  initialValue?: string;
  updateHandler?: (
    htmlState: string,
    jsonState: string,
    textState: string
  ) => void;
}

const DEFAULT_CONFIG = {
  id: '',
  height: 410,
  editable: true,
  fitToContent: false,
  toolset: DEFAULT_TOOLSET,
  placeholderText: '',
  updateHandler: () => {
    console.log('Updated');
  },
};

export const ConfigContext = createContext<BubbleConfig>(DEFAULT_CONFIG);
